/* @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography, Typography2 } from '@coursera/cds-core';

import EnrollmentDialogCTAButton from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/EnrollmentDialogCTAButton';
import styles from 'bundles/degree-home/components/v3-dpm/components/EnrollmentDialog/styles';

import _t from 'i18n!nls/degree-home';

interface Props {
  courseSlug: string;
}
const OpenContent = ({ courseSlug, ...styleProps }: Props) => (
  <div {...styleProps}>
    {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
    <Typography variant="h2semibold">
      {_t('Enroll in a non-credit degree course and upgrade to for-credit later')}
    </Typography>
    <Typography2 component="p" css={styles.paragraphAndButtonPadding}>
      {_t(
        'Need extra flexibility? Enroll in the non-credit version of the course and start learning at your own pace. Upgrade to for-credit when the course is offered for-credit by the university. Your progress will carry over and the credit will count towards your degree.'
      )}
    </Typography2>
    <EnrollmentDialogCTAButton
      trackingName="view_non_credit_course"
      href={`/learn/${courseSlug}`}
      ctaLabel={_t('View non-credit course')}
    />
  </div>
);

export default OpenContent;
